import { PublicFooter, PublicHeader } from "../components/PublicPageChrome";

const Section = ({ title, children }) => (
  <section className="space-y-2">
    <h2 className="font-heading font-semibold text-lg text-ink">{title}</h2>
    <div className="text-sm text-ink/70 leading-relaxed space-y-2">{children}</div>
  </section>
);

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-cream text-ink font-body">
      <PublicHeader maxWidthClass="max-w-2xl" showSignIn={false} />
      <main className="max-w-2xl mx-auto px-5 pb-16 space-y-8">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-medium text-ink/50">Legal</p>
          <h1 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight mt-1">Terms of Service</h1>
          <p className="text-sm text-ink/50 mt-2">Last updated 5 August 2026</p>
        </div>

        <Section title="1. Who we are">
          <p>
            Mnandi ("Mnandi", "we", "us") is a costing and quoting tool for caterers, operated from the United
            Kingdom and billed in GBP. These Terms govern your use of the Mnandi web app at mnandi.app. By creating
            an account you agree to them.
          </p>
        </Section>

        <Section title="2. The service">
          <p>
            Mnandi lets you log ingredient purchases (including by photographing receipts or describing a purchase
            by voice), build recipes, and calculate a price floor and quotes for catering jobs. It's a costing tool,
            not accounting or tax software, and the figures it produces are only as accurate as the ingredient
            prices and recipe data you enter.
          </p>
        </Section>

        <Section title="3. Accounts, trials and billing">
          <p>
            New subscriptions include a 14-day free trial. Unless you cancel before the trial ends, your card will
            be charged automatically at the advertised monthly price for your chosen plan, billed in GBP via Stripe.
            You can cancel or change plans at any time from Settings → Manage billing; cancelling stops future
            billing but does not refund the current billing period.
          </p>
          <p>
            You're responsible for keeping your login credentials secure and for the accuracy of the data you enter.
          </p>
        </Section>

        <Section title="4. Promotional codes and discounts">
          <p>
            From time to time we offer discount codes (for example through partners or creators). Discounts apply
            only under the terms stated when the code was issued, are not combinable unless explicitly stated, and
            we may withdraw or change a promotion at any time without affecting subscribers already on it.
          </p>
        </Section>

        <Section title="5. Acceptable use">
          <p>
            Don't use Mnandi to store or process data you don't have the right to use, attempt to disrupt or
            reverse-engineer the service, or resell access without our agreement.
          </p>
        </Section>

        <Section title="6. Disclaimer and liability">
          <p>
            Mnandi is provided "as is". We work to keep pricing calculations correct, but you remain responsible for
            reviewing any quote or price floor before sending it to a customer. To the extent permitted by law, our
            liability for losses arising from use of the service is limited to the amount you paid us in the 12
            months before the claim.
          </p>
        </Section>

        <Section title="7. Ending your account">
          <p>
            You can stop using Mnandi and cancel your subscription at any time. We may suspend or close accounts
            that breach these Terms or abuse the service.
          </p>
        </Section>

        <Section title="8. Governing law">
          <p>These Terms are governed by the laws of England and Wales.</p>
        </Section>

        <Section title="9. Contact">
          <p>Questions about these Terms: <a className="underline" href="mailto:hello@mnandi.app">hello@mnandi.app</a>.</p>
        </Section>
      </main>
      <PublicFooter maxWidthClass="max-w-2xl" />
    </div>
  );
}
